// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2xjbP","head":"ProcedureTableInfo_head__3EoFq"};